import React from 'react';
import {AutoComplete, Button, Form, Input, Modal, notification, Select, Typography} from "antd";
import ApiService from "../../../services/ApiService"
import {EsriProvider} from 'leaflet-geosearch';
import COUNTRY from "country-json/src/country-by-abbreviation.json";
import {getCountry} from "../../../components/permissions/functions";
import {t} from "@lingui/core/macro"
import {Trans} from "@lingui/react/macro"

const provider = new EsriProvider();
const {Search} = Input;
const {Text} = Typography;
const {Option} = Select;

export default class ModalEditAdresse extends React.Component {

    constructor(props) {
        super(props);
        props.getRef(this)
    }

    initialState = {
        visible: false,
        loading: false,
        id: null,
        edit: false,
        defaultData: {},
        adresseOptions: []
    };

    state = this.initialState

    async show(contact, data = null) {
        if (data) {
            var newData = {...data}
            this.setState({visible: true, contact: contact, id: newData.id, defaultData: newData, edit: true})
        } else {
            this.setState({visible: true, contact: contact, defaultData: {pays: COUNTRY.find(i => i.abbreviation === getCountry())?.country}})
        }
    }

    onSearch = (text) => {
        this.setState({text});
    }

    close() {
        this.setState(this.initialState)
    }

    async onSubmit(data) {
        if (this.state.id) {
            data.id = this.state.id
        }

        this.setState({loading: true})

        var res = await ApiService.post("/contact/adresse/edit/" + this.state.contact, data)

        if (res.success) {
            notification.success({
                message: this.state.edit ? t`Édition réussie` : t`Ajout réussi`
            })

            this.close()
            if (this.props.onFinish) {
                this.props.onFinish()
            }
        } else {
            notification.error({
                message: this.state.edit ? t`Erreur lors de l'édition` : t`Erreur lors de l'ajout`
            })
        }

        this.setState({loading: false})
    }

    render() {
        return (
            <Modal width="100%" title={this.state.edit ? t`Éditer une Adresse` : t`Ajouter une Adresse`}
                   open={this.state.visible} destroyOnClose closable footer={null} onCancel={() => this.close()}>

                <Form
                    labelCol={{span: 5}}
                    ref={(ref) => this.form = ref}
                    initialValues={this.state.defaultData}
                    onFinish={(data) => this.onSubmit(data)}
                >

                    <Form.Item
                        label={t`Nom ou Raison sociale`}
                        name="nom"
                        rules={[{required: true, message: t`Ce champ est obligatoire`}]}
                    >
                        <Input placeholder={t`Bureau, Domicile Etc.`}/>
                    </Form.Item>

                    <Form.Item
                        label={t`Siren`}
                        name="siren"
                    >
                        <Input placeholder={t`(Optionnelle)`}/>
                    </Form.Item>

                    <Form.Item
                        label={t`Adresse`}
                        name="adresse"
                    >
                        <AutoComplete
                            options={this.state.adresseOptions.map(i => {
                                return {
                                    object: i,
                                    value: i.adresse,
                                    label: i.raw,
                                }
                            })}
                            onSearch={(inputValue) => {
                                clearTimeout(this.timeoutAdresse)
                                this.timeoutAdresse = setTimeout(async () => {
                                    var value = inputValue.trim()
                                    if (value) {
                                        var results = await provider.search({query: value})
                                        var finalResult = results.map((item) => {
                                            var arrayValue = item.label.split(",")
                                            return {
                                                raw: item.label,
                                                adresse: arrayValue[0],
                                                postal: arrayValue[1],
                                                ville: arrayValue[2]
                                            }
                                        })
                                        this.setState({adresseOptions: finalResult})
                                    }
                                }, 500)
                            }}
                            onSelect={(value, option) => {
                                this.form.setFieldValue("postal", option.object.postal)
                                this.form.setFieldValue("ville", option.object.ville)
                            }}
                            placeholder={t`Adresse`}
                        />
                    </Form.Item>

                    <Form.Item
                        label={t`Code Postal`}
                        name="postal"
                    >
                        <Input placeholder={t`Code Postal`}/>
                    </Form.Item>

                    <Form.Item
                        label={t`Ville`}
                        name="ville"
                    >
                        <Input placeholder={t`Ville`}/>
                    </Form.Item>

                    <Form.Item
                        label={t`Pays`}
                        name="pays"
                    >
                        <Select showSearch placeholder={t`Pays`}>
                            {COUNTRY.map(i => {
                                return (
                                    <Select.Option value={i.country}>{i.country}</Select.Option>
                                )
                            })}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        label={t`Note`}
                        name="note_adresse"
                    >
                        <Input.TextArea placeholder={t`(Optionnelle)`}/>
                    </Form.Item>

                    <Form.Item style={{display: "flex", justifyContent: "flex-end"}}>
                        <Button type="primary" htmlType="submit" loading={this.state.loading}>
                            <Trans>Valider</Trans>
                        </Button>
                    </Form.Item>

                </Form>
            </Modal>
        )
    }
}
